<template>
  <v-app id="inspire">
    <!-- <div class="tpl-snow">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
  	</div> -->

    <div class="header">
      <div class="main-wrapper">
        <v-container>

          <v-row
            align="center"
          >

            <!-- LOGO -->
            <v-col
              cols="7"
              md="3"
              class="d-flex align-center"
            >
              <img
                class="brand-logo"
                :src="require('@/assets/logo-xs.png')"
                @click="redirectHomePage('HomePage')"
                alt="Dino Toys"
              >
            </v-col>

            <!-- SEARCH -->
            <v-col
              md="6"
              class="d-none d-md-block"
            >
              <div class="search-box">
                <v-text-field
                  solo
                  flat
                  hide-details
                  class="search-input"
                  prepend-inner-icon="mdi-magnify"
                  label="Buscar juguetes, perfumes, muñecas..."
                  v-model="text"
                  @keyup.enter="productSearch"
                ></v-text-field>
              </div>
            </v-col>

            <!-- ACTIONS -->
            <v-col
              cols="5"
              md="3"
              class="text-right"
            >
              <v-btn icon large @click="orderTrackingLogin">
                <v-icon>mdi-heart-outline</v-icon>
              </v-btn>

              <v-btn icon large>
                <v-icon>mdi-account-outline</v-icon>
              </v-btn>

              <v-btn
                icon
                large
                @click="checkoutCart"
              >
                <v-badge
                  :content="quantity"
                  color="red"
                >
                  <v-icon>
                    mdi-cart-outline
                  </v-icon>
                </v-badge>
              </v-btn>
            </v-col>

          </v-row>

          <!-- MOBILE SEARCH -->
          <div class="search-box mt-2 d-md-none">
            <v-text-field
              solo
              flat
              hide-details
              class="search-input"
              prepend-inner-icon="mdi-magnify"
              label="Buscar productos..."
              v-model="text"
              @keyup.enter="productSearch"
            ></v-text-field>
          </div>
        </v-container>
      </div>
    </div>

    <v-main>
      <div class="main-wrapper">

      <!-- CONTENT -->
      <slot name="content"></slot>

      <!-- FOOTER -->
      <div class="footer mt-16">
          <v-container class="py-14">
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <div
                  style="font-size:34px; font-weight:800;"
                >
                  Dino Toys
                </div>

                <div
                  class="mt-4"
                  style="opacity:.8; line-height:1.8;"
                >
                  Los juguetes más divertidos,
                  modernos y adorados por los pequeños.
                </div>
              </v-col>

              <v-col
                cols="6"
                md="2"
              >
                <div class="font-weight-bold">
                  Categorías
                </div>

                <template 
                  v-for="cat in moduls.slice(0,5)"
                >
                  <div class="mt-2">{{ cat.name }}</div>
                </template>

                <div class="mt-2">Y MÁS...</div>
              </v-col>

              <v-col
                cols="6"
                md="3"
              >
                <div class="font-weight-bold">
                  Atención
                </div>

                <div class="mt-4">
                  Whatsapp
                </div>

                <div class="mt-2">
                  Delivery Lima
                </div>

                <div class="mt-2">
                  Envíos a provincia
                </div>
              </v-col>

              <v-col
                cols="12"
                md="3"
              >
                <div class="font-weight-bold">
                  Síguenos
                </div>

                <div class="mt-4">

                  <v-btn icon dark target="_blank" href="https://www.facebook.com/MUNDODINOTOYS/">
                    <v-icon>mdi-facebook</v-icon>
                  </v-btn>

                  <v-btn icon dark target="_blank" href="https://www.instagram.com/mundodinotoys.peru/?hl=es">
                    <v-icon>mdi-instagram</v-icon>
                  </v-btn>

                  <v-btn icon dark target="_blank" href="https://www.tiktok.com/@dinotoys.peru">
                    <v-icon>mdi-music-note</v-icon>
                  </v-btn>

                  <v-btn icon dark target="_blank" href="https://www.youtube.com/@kalethtube828">
                    <v-icon>mdi-youtube</v-icon>
                  </v-btn>

                </div>
              </v-col>
            </v-row>

            <v-divider
              dark
              class="my-8"
            ></v-divider>

            <div
              class="text-center"
              style="opacity:.7;"
            >
              © 2026 Dino Toys - Todos los derechos reservados
            </div>
            <div
              class="text-center"
              style="opacity:.7;"
            >
              Precios disponibles solo en www.dino-toys.com. Precios online publicados pueden incluir descuento adicional. Precios sujetos a variaciones sin previo aviso. Productos sujetos a disponibilidad de stock.
            </div>
          </v-container>

        </div>
      </div>

      <v-btn
        fab
        x-large
        dark
        color="green"
        class="floating-whatsapp"
        target="_blank"
        :href="goWhatsapp()"
      >
        <v-icon size="34">
          mdi-whatsapp
        </v-icon>
      </v-btn>
    </v-main>

  </v-app>
</template>
<script>
  import CartStore from '@/stores/Cart'
  import axios from 'axios'

  export default {
    name: 'DefaultLayout',
    data: () => ({
      text: '',
      moduls: [],
    }),
    computed: {
      quantity() {
        return CartStore.getters.quantity;
      }
    },
    methods: {
      getModuls() {
        axios.get(process.env.DINO.PATH.GET_MODULS)
        .then(response => {
          this.moduls = response.data;
          localStorage.setItem('moduls', JSON.stringify(response.data));
        })
        .catch(err => {
          this.moduls = JSON.parse(localStorage.getItem('moduls'));
        });
      },
      redirectHomePage: function(name) {
        this.$router.push({ name: name }).catch(err => {});
      },
      productSearch: function() {
        this.$router.push({ name:'Products', query: { q: this.text, orderBy: 'OrderByReleaseDateDESC', page: 1 } }).catch(err => {});
      },
      checkoutCart: function() {
        this.$router.push({ name: 'Cart' }).catch(err => {});
      },
      orderTrackingLogin: function() {
        this.$router.push({ name: 'OrderTrackingLogin' }).catch(err => {});
      },
      redirectModul: function (group) {
        this.$router.push({ name:'Products', query: { q: group } }).catch(err => {});
      },
      goWhatsapp () {
        const urlWhatsapp = `*DINO!* - Quiero información de sus productos.%0D%0A%0D%0A_%C2%A1+Gracias+%21_`;
        return `https://api.whatsapp.com/send?phone=51987839662&text=${urlWhatsapp}`;
      },
    },
    mounted: function () {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      this.getModuls();
    },
  }
</script>

<style scoped>
  :root{
    --primary:#1565ff;
    --secondary:#ff4d6d;
    --bg:#f5f7fb;
    --dark:#1f2937;
  }

  *{
    font-family:'Poppins',sans-serif;
  }

  html{
    scroll-behavior:smooth;
  }

  body{
    background:var(--bg);
    overflow-x:hidden;
  }

  .main-wrapper{
    max-width:1500px;
    margin:auto;
  }

  /* HEADER */

  .header{
    position:sticky;
    top:0;
    z-index:999;
    backdrop-filter: blur(18px);
    background:rgba(255,255,255,.92);
    box-shadow:0 4px 20px rgba(0,0,0,.04);
  }

  .logo-text{
    font-weight:800;
    font-size:24px;
    color:var(--dark);
    letter-spacing:.3px;
  }

  .search-box{
    background:white;
    border-radius:20px;
    box-shadow:
      0 10px 25px rgba(0,0,0,.06);
    border:1px solid #edf1f7;
  }

  .search-input .v-input__slot{
    box-shadow:none !important;
    background:transparent !important;
  }

  .brand-logo {
    cursor: pointer;
    display: block;
    width: auto;
    height: 72px;
    max-width: 100%;
  }

  @media (min-width: 960px) {
    .brand-logo {
      height: 65px;
    }
  }

  /* FOOTER */

  .footer{
    background:
    linear-gradient(
      135deg,
      #1b74e4,
      #1b74e4
    );

    border-radius:20px 20px 0 0;
    color:white;
  }

  /* FLOAT */

  .floating-whatsapp{
    position:fixed;
    bottom:22px;
    right:22px;
    z-index:999;
  }

  @-moz-keyframes nieve{
    from{top:-40px;}
      to{top:101%;}
  }
  @-webkit-keyframes nieve{
    from{top:-40px;}
      to{top:2000px;}
  }
  @keyframes nieve{
    from{top:-40px;}
      to{top:2000px;}
  }

  @-moz-keyframes horiz2{
      20%{transform:translateX(0);}
      50%{transform:translateX(150px);}
      80%{transform:translateX(0);}
  }
  @-webkit-keyframes horiz2{
      20%{transform:translateX(0);}
      50%{transform:translateX(150px);}
      80%{transform:translateX(0);}
  }
  @keyframes horiz2{
      20%{transform:translateX(0);}
      50%{transform:translateX(-70px);}
      80%{transform:translateX(0);}
  }

  @-moz-keyframes horiz{
      20%{transform:translateX(0);}
      50%{transform:translateX(150px);}
      80%{transform:translateX(0);}
  }
  @-webkit-keyframes horiz{
      20%{transform:translateX(0);}
      50%{transform:translateX(150px);}
      80%{transform:translateX(0);}
  }
  @keyframes horiz{
      20%{transform:translateX(0);}
      50%{transform:translateX(150px);}
      80%{transform: translateX(0);}
  }

  .tpl-snow > div{position:fixed;-webkit-animation:ease-in infinite normal;-moz-animation:ease-in infinite normal;animation:ease-in infinite normal;}

  .tpl-snow > div{z-index:9999999999999;width:10px;height:10px;-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;background-color:#fff;-webkit-animation-name:nieve,horiz;-moz-animation-name:nieve,horiz;animation-name:nieve,horiz;}
  .tpl-snow > div:nth-of-type(odd){width:5px; height:5px;-webkit-animation-name:nieve,horiz2;-moz-animation-name:nieve,horiz2;animation-name:nieve,horiz2;}

  .tpl-snow > div:nth-of-type(1){left:40px;-webkit-animation-duration:5.5s;-moz-animation-duration:5.5s;animation-duration:5.5s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(2){left:120px;-webkit-animation-duration:7s;-moz-animation-duration:7s;animation-duration:7s;}
  .tpl-snow > div:nth-of-type(3){left:200px;-webkit-animation-duration:8s;-moz-animation-duration:8s;animation-duration:8s;}
  .tpl-snow > div:nth-of-type(4){left:20%;-webkit-animation-duration:6s;-moz-animation-duration:6s;animation-duration:6s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(5){left:30%;-webkit-animation-duration:9s;-moz-animation-duration:9s;animation-duration:9s;}
  .tpl-snow > div:nth-of-type(6){left:40%;-webkit-animation-duration:7.2s;-moz-animation-duration:7.2s;animation-duration:7.2s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(7){left:50%;-webkit-animation-duration:10s;-moz-animation-duration:10s;animation-duration:10s;}
  .tpl-snow > div:nth-of-type(8){left:60%;-webkit-animation-duration:6.4s;-moz-animation-duration:6.4s;animation-duration:6.4s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(9){left:70%;-webkit-animation-duration:10s;-moz-animation-duration:10s;animation-duration:10s;-webkit-animation-delay:1.4s;-moz-animation-delay:1.4s;animation-delay:1.4s;}
  .tpl-snow > div:nth-of-type(10){left:80%;-webkit-animation-duration:8s;-moz-animation-duration:8s;animation-duration:8s;}
  .tpl-snow > div:nth-of-type(11){left:90%;-webkit-animation-duration:7.1s;-moz-animation-duration:7.1s;animation-duration:7.1s;-webkit-animation-delay:2s;-moz-animation-delay:2s;animation-delay:2s;}
  .tpl-snow > div:nth-of-type(12){left:99%;-webkit-animation-duration:6.6s;-moz-animation-duration:6.6s;animation-duration:6.6s;-webkit-animation-delay:1.6s;-moz-animation-delay:1.6s;animation-delay:1.6s;}
  .tpl-snow > div:nth-of-type(13){left:10px;-webkit-animation-duration:10.2s;-moz-animation-duration:10.2s;animation-duration:10.2s;}
  .tpl-snow > div:nth-of-type(14){left:180px;-webkit-animation-duration:12s;-moz-animation-duration:12s;animation-duration:12s;}
  .tpl-snow > div:nth-of-type(15){left:213px;-webkit-animation-duration:7.3s;-moz-animation-duration:7.3s;animation-duration:7.3s;-webkit-animation-delay:.5s;-moz-animation-delay:.5s;animation-delay:.5s;}
  .tpl-snow > div:nth-of-type(16){left:23%;-webkit-animation-duration:9.2s;-moz-animation-duration:9.2s;animation-duration:9.2s;}
  .tpl-snow > div:nth-of-type(17){left:38%;-webkit-animation-duration:5s;-moz-animation-duration:5s;animation-duration:5s;}
  .tpl-snow > div:nth-of-type(18){left:45%;-webkit-animation-duration:15s;-moz-animation-duration:15s;animation-duration:15s;}
  .tpl-snow > div:nth-of-type(19){left:58%;-webkit-animation-duration:5s;-moz-animation-duration:5s;animation-duration:5s;}
  .tpl-snow > div:nth-of-type(20){left:64%;-webkit-animation-duration:12s;-moz-animation-duration:12s;animation-duration:12s;}
  .tpl-snow > div:nth-of-type(21){left:76%;-webkit-animation-duration:5.6s;-moz-animation-duration:5.6s;animation-duration:5.6s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(22){left:86%;-webkit-animation-duration:8.5s;-moz-animation-duration:8.5s;animation-duration:8.5s;}
  .tpl-snow > div:nth-of-type(23){left:83%;-webkit-animation-duration:14.4s;-moz-animation-duration:14.4s;animation-duration:14.4s;}
  .tpl-snow > div:nth-of-type(24){left:95%;-webkit-animation-duration:12s;-moz-animation-duration:12s;animation-duration:12s;}
  .tpl-snow > div:nth-of-type(25){left:55px;-webkit-animation-duration:8.7s;-moz-animation-duration:8.7s;animation-duration:8.7s;-webkit-animation-delay:1.2s;-moz-animation-delay:1.2s;animation-delay:1.2s;}
  .tpl-snow > div:nth-of-type(26){left:133px;-webkit-animation-duration:5.2s;-moz-animation-duration:5.2s;animation-duration:5.2s;}
  .tpl-snow > div:nth-of-type(27){left:215px;-webkit-animation-duration:10.4s;-moz-animation-duration:10.4s;animation-duration:10.4s;-webkit-animation-delay:1.6s;-moz-animation-delay:1.6s;animation-delay:1.6s;}
  .tpl-snow > div:nth-of-type(28){left:26%;-webkit-animation-duration:9s;-moz-animation-duration:9s;animation-duration:9s;}
  .tpl-snow > div:nth-of-type(29){left:33%;-webkit-animation-duration:12s;-moz-animation-duration:12s;animation-duration:12s;}
  .tpl-snow > div:nth-of-type(30){left:49%;-webkit-animation-duration:9.4s;-moz-animation-duration:9.4s;animation-duration:9.4s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(31){left:55%;-webkit-animation-duration:9.1s;-moz-animation-duration:9.1s;animation-duration:9.1s;}
  .tpl-snow > div:nth-of-type(32){left:68%;-webkit-animation-duration:9.6s;-moz-animation-duration:9.6s;animation-duration:9.6s;-webkit-animation-delay:.5s;-moz-animation-delay:.5s;animation-delay:.5s;}
  .tpl-snow > div:nth-of-type(33){left:73%;-webkit-animation-duration:12.4s;-moz-animation-duration:12.4s;animation-duration:12.4s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(34){left:85%;-webkit-animation-duration:9s;-moz-animation-duration:9s;animation-duration:9s;-webkit-animation-delay:1.5s;-moz-animation-delay:1.5s;animation-delay:1.5s;}
  .tpl-snow > div:nth-of-type(35){left:93%;-webkit-animation-duration:5s;-moz-animation-duration:5s;animation-duration:5s;}
  .tpl-snow > div:nth-of-type(36){left:99%;-webkit-animation-duration:10.6s;-moz-animation-duration:10.6s;animation-duration:10.6s;}
  .tpl-snow > div:nth-of-type(37){left:15px;-webkit-animation-duration:9.6s;-moz-animation-duration:9.6s;animation-duration:9.6s;}
  .tpl-snow > div:nth-of-type(38){left:99px;-webkit-animation-duration:7.5s;-moz-animation-duration:7.5s;animation-duration:7.5s;}
  .tpl-snow > div:nth-of-type(39){left:260px;-webkit-animation-duration:11s;-moz-animation-duration:11s;animation-duration:11s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(40){left:28%;-webkit-animation-duration:19s;-moz-animation-duration:19s;animation-duration:19s;}
  .tpl-snow > div:nth-of-type(41){left:35%;-webkit-animation-duration:14s;-moz-animation-duration:14s;animation-duration:14s;}
  .tpl-snow > div:nth-of-type(42){left:43%;-webkit-animation-duration:5.6s;-moz-animation-duration:5.6s;animation-duration:5.6s;}
  .tpl-snow > div:nth-of-type(43){left:53%;-webkit-animation-duration:8.8s;-moz-animation-duration:8.8s;animation-duration:8.8s;-webkit-animation-delay:1s;-moz-animation-delay:1s;animation-delay:1s;}
  .tpl-snow > div:nth-of-type(44){left:66%;-webkit-animation-duration:16s;-moz-animation-duration:16s;animation-duration:16s;}
  .tpl-snow > div:nth-of-type(45){left:78%;-webkit-animation-duration:6s;-moz-animation-duration:6s;animation-duration:6s;}
  .tpl-snow > div:nth-of-type(46){left:88%;-webkit-animation-duration:9.5s;-moz-animation-duration:9.5s;animation-duration:9.5s;-webkit-animation-delay:.5s;-moz-animation-delay:.5s;animation-delay:.5s;}
  .tpl-snow > div:nth-of-type(47){left:94%;-webkit-animation-duration:7.6s;-moz-animation-duration:7.6s;animation-duration:7.6s;}
  .tpl-snow > div:nth-of-type(48){left:96%;-webkit-animation-duration:8.2s;-moz-animation-duration:8.2s;animation-duration:8.2s;-webkit-animation-delay:.3s;-moz-animation-delay:.3s;animation-delay:.3s;}

  @media(max-width:600px){
    .tpl-snow > div:nth-of-type(24) ~ *{display:none;}
  }

  @media(max-width:800px){
    .tpl-snow > div:nth-of-type(36) ~ *{display:none;}
  }
</style>



// WEBPACK FOOTER //
// src/layouts/DefaultLayout.vue